module.exports = __webpack_public_path__ + "img/m_event_page3.1784c20f.png";